import { useEffect, useState } from 'react';
// import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { useTranslation } from 'react-i18next';
import { ProfileService } from '../../components/font-end/Profile/ProfileService';
import { SubmitUniformSurvey } from '../../components/font-end/UniformSurvey/SubmitUniformSurvey';
import { UserBasicInfo } from '../../services/ApiUniformSurvey';
import { ProfileSurveyType } from '../../model/datatype';

export const ChooseUniform = (props: any) => {
  let { t } = useTranslation();
  const [data, setData] = useState<ProfileSurveyType | null>(null);

  useEffect(() => {
    UserBasicInfo()
      .then((response) => {
        //console.log(response);
        const getData: any = response;
        setData(getData);
      })
      .catch((error: any) => {
        // Silent fail
      });
  }, []);
  return (
    <>
    <ProfileService logo="show" profile={data} />
      <SubmitUniformSurvey profile={data} />
      {/* <Menubar /> */}
    </>
  );
};
